import { createContext, useContext, useState } from 'react';

const LogsModalContext = createContext(null);

export function LogsModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const value = {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };

  return <LogsModalContext.Provider value={value}>{children}</LogsModalContext.Provider>;
}

export const useLogsModal = () => useContext(LogsModalContext);
